import { gql } from '@apollo/client'

export const REASSIGN_RENTAL = gql`
  mutation rentalReassign($rentalID: ID!, $employeeID: ID!) {
    rentalReassign(rentalID: $rentalID, employeeID: $employeeID) {
      id
    }
  }
`
